import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { MuiPickersUtilsProvider, DateTimePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';

const renderDateField = ({
  label,
  input,
  formatTime,
  meta: { touched, invalid, error },
  children,
  ...custom
}) => (
  <DateTimePicker
    label={label || ''}
    placeholder={label}
    error={touched && invalid}
    helperText={touched && error}
    format={formatTime}
    {...input}
    {...custom}>
    {children}
  </DateTimePicker>
);

renderDateField.propTypes = {
  label: PropTypes.string,
  formatTime: PropTypes.string,
  input: PropTypes.instanceOf(Object).isRequired,
  meta: PropTypes.instanceOf(Object).isRequired,
  children: PropTypes.node,
};

renderDateField.defaultProps = {
  label: '',
  formatTime: '',
  children: null,
};

// перегрузка пропса format т.к. Field его перехватывает
export default ({ format, ...props }) => (
  <MuiPickersUtilsProvider utils={DateFnsUtils}>
    <Field component={renderDateField} {...props} formatTime={format} />
  </MuiPickersUtilsProvider>
);
